__turbopack_context__.v({
  "bloghd": "Footer-module-scss-module__HRo9YW__bloghd",
  "bottomFooter": "Footer-module-scss-module__HRo9YW__bottomFooter",
  "btnCustom": "Footer-module-scss-module__HRo9YW__btnCustom",
  "container": "Footer-module-scss-module__HRo9YW__container",
  "countrySelectionBox": "Footer-module-scss-module__HRo9YW__countrySelectionBox",
  "footer": "Footer-module-scss-module__HRo9YW__footer",
  "footerAboutUs": "Footer-module-scss-module__HRo9YW__footerAboutUs",
  "footerLinks": "Footer-module-scss-module__HRo9YW__footerLinks",
  "formControl": "Footer-module-scss-module__HRo9YW__formControl",
  "ftLogo": "Footer-module-scss-module__HRo9YW__ftLogo",
  "lastServiceBox": "Footer-module-scss-module__HRo9YW__lastServiceBox",
  "newsletterBlock": "Footer-module-scss-module__HRo9YW__newsletterBlock",
  "newsletterFooterForm": "Footer-module-scss-module__HRo9YW__newsletterFooterForm",
  "openSubNav": "Footer-module-scss-module__HRo9YW__openSubNav",
  "outerSubNav": "Footer-module-scss-module__HRo9YW__outerSubNav",
  "socialLinks": "Footer-module-scss-module__HRo9YW__socialLinks",
  "top_0": "Footer-module-scss-module__HRo9YW__top_0",
});
